module.exports = __webpack_public_path__ + "media/วิโรจน์ก้าวไก่.35884a46.mp3";